function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.49903 3.49805H17.4698C17.7454 3.49805 17.9688 3.27464 17.9688 2.99903C17.9688 2.72344 17.7454 2.5 17.4698 2.5H2.49903C2.22341 2.5 2 2.72344 2 2.99903C2 3.27464 2.22341 3.49805 2.49903 3.49805Z",
  fill: "#99A6B0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.501 13.9775H2.53028C2.25466 13.9775 2.03125 14.201 2.03125 14.4766C2.03125 14.7522 2.25466 14.9756 2.53028 14.9756H9.51578V16.0789C9.67047 16.019 9.84015 15.9891 10.0148 15.9891C10.1895 15.9891 10.3591 16.019 10.5138 16.0789V14.9756H17.501C17.7766 14.9756 18.0001 14.7522 18.0001 14.4766C18.0001 14.201 17.7766 13.9775 17.501 13.9775Z",
  fill: "#99A6B0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.50244 3.99756C3.22798 3.99756 3.00342 4.22212 3.00342 4.49658V12.98C3.00342 13.2595 3.22798 13.479 3.50244 13.479H16.4771C16.7516 13.479 16.9761 13.2595 16.9761 12.98V4.49658C16.9761 4.22212 16.7516 3.99756 16.4771 3.99756H3.50244ZM7.26012 11.977H5.76304C5.6283 11.977 5.51353 11.8672 5.51353 11.7275V5.73416C5.51353 5.59444 5.6283 5.47968 5.76304 5.48464L7.25013 5.48964C7.38987 5.48964 7.49964 5.59944 7.49964 5.73915L7.50963 11.7275C7.50963 11.8672 7.39983 11.977 7.26012 11.977ZM10.7533 11.977H9.25622C9.12147 11.977 9.00671 11.8672 9.00671 11.7275V6.73221C9.00671 6.5925 9.12147 6.47773 9.25622 6.48269L10.7433 6.48769C10.883 6.48769 10.9928 6.59749 10.9928 6.7372L11.0028 11.7275C11.0028 11.8672 10.893 11.977 10.7533 11.977ZM14.2165 11.977H12.7195C12.5797 11.977 12.4699 11.8672 12.4699 11.7275V7.73026C12.4699 7.59055 12.5847 7.47578 12.7195 7.48075L14.2115 7.47578C14.3512 7.48075 14.4611 7.59055 14.4611 7.72529L14.466 11.7275C14.466 11.8672 14.3562 11.977 14.2165 11.977Z",
  fill: "#99A6B0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0156 18.4857C10.5668 18.4857 11.0137 18.0389 11.0137 17.4877C11.0137 16.9365 10.5668 16.4896 10.0156 16.4896C9.46442 16.4896 9.01758 16.9365 9.01758 17.4877C9.01758 18.0389 9.46442 18.4857 10.0156 18.4857Z",
  fill: "#99A6B0"
});

const SvgBiToolsIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBiToolsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bi-tools-icon.aae6a708.svg";
export { ForwardRef as ReactComponent };